// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.cb_container[data-v-c929e9e8]:active:hover {\n  transform: scale(0.95);\n}\n", ""]);
// Exports
module.exports = exports;
